import type { AdvancedFilterModel, FilterModel } from "ag-grid-community";

import type {
  BillingInvoice,
  BillingRoutes,
  MasterInvoicesData,
} from "@/features/admin/types";

export type InvoiceTableRow = {
  id: string;
  status: "pending" | "completed";
  invoiceId: number | null;
  orgId: number;
  orgName: string;
  createdAt: Date | null;
  total: number;
};

export type MasterInvoiceTableRow =
  | { kind: "pending"; id: string; total: number }
  | {
      kind: "completed";
      id: string;
      docId: number;
      createdAt: Date;
      recipientEmail: string | null;
      total: number;
    };

export function toInvoiceTableRows(
  items: BillingInvoice[] | undefined,
): InvoiceTableRow[] {
  return (items ?? []).map((item) => ({
    id:
      item.status === "completed"
        ? item.id.toString()
        : `pending-${item.orgId}`,
    status: item.status,
    invoiceId: item.status === "completed" ? item.id : null,
    orgId: item.orgId,
    orgName: item.org?.name ?? "",
    createdAt: item.status === "completed" ? item.createdAt : null,
    total: item.total?.toNumber() ?? 0,
  }));
}

export function getPendingInvoiceTotal(
  data: BillingRoutes["invoices"] | undefined,
) {
  return data?.pending.total.toNumber() ?? 0;
}

export function toMasterInvoiceTableRows(
  items: MasterInvoicesData["data"] | undefined,
): MasterInvoiceTableRow[] {
  return (items ?? []).map((item) => {
    if (item.kind === "pending") {
      return {
        kind: "pending",
        id: "pending",
        total: item.total.toNumber(),
      };
    }

    return {
      kind: "completed",
      id: item.id.toString(),
      docId: item.id,
      createdAt: item.createdAt,
      recipientEmail: item.recipientEmail,
      total: item.total.toNumber(),
    };
  });
}

// AG Grid `AdvancedFilterModel` (tree root) includes `filterType`; column `FilterModel` does not.
// Return `undefined` for advanced mode; pass column `FilterModel` through as `T`.
export function toInvoiceAdminFilterModel<T>(
  filterModel: AdvancedFilterModel | FilterModel | null | undefined,
): T | undefined {
  if (!filterModel || "filterType" in filterModel) return undefined;
  return filterModel as T;
}
